<template>
  <div class="container">
    <transition key="content" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div class="content-background" v-if="showContent"></div>
    </transition>
    <transition key="book" enter-active-class="animated zoomIn" leave-active-class="animated fadeOut">
      <div class="book-wrapper" v-if="showContent">
        <div class="book">
          <div class="book-left">
            <div class="book-item-video" @click="showYouTubeVideo('9sGkm70z5tw')">
              <img class="video-thumbnail" src="../../assets/img/video/9sGkm70z5tw_thumb.png" alt="VR schoolのご紹介">
              <p class="video-title">VR schoolのご紹介</p>
              <p class="video-description">
                VR schoolの概要をご紹介した動画です。
              </p>
            </div>
          </div>
          <router-link class="back-button-south" to="/corridor/a11s">廊下に戻る</router-link>
        </div>
      </div>
    </transition>

    <modal v-if="showModal" @close="hideYouTubeVideo">
      <iframe class="youtube-embed" :src="'https://www.youtube.com/embed/' + showVideoID" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </modal>
  </div>
</template>

<script>
  import Modal from "@/components/Modal";

  export default {
    name: "Library",
    components: {
      Modal
    },
    data() {
      return {
        showContent: false,
        showVideoID: "",
        showModal: false,
      }
    },
    methods: {
      showYouTubeVideo(videoID) {
        this.$emit("mute");
        this.showVideoID = videoID;
        this.showModal = true;
      },
      hideYouTubeVideo() {
        this.showModal = false;
        this.$emit("unmute");
      }
    },
    mounted() {
      setTimeout(() => {
        this.showContent = true;
        this.$emit("play-sound", "audio/vrschool_se_floatbook.mp3");
      }, 1500);
    }
  }
</script>

<style scoped>

  .container {
    position: relative;
    background: url("../../assets/img/building_a/library_bg.png");
    background-size: contain;
    height: 100%;
  }

  .content-background {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
  }

  .book-wrapper {
    position: relative;
    background: url("../../assets/img/building_a/library_book.png") no-repeat fixed center;
    background-size: contain;
    height: 100%;
    overflow: hidden;
    z-index: 2;
  }

  .book {
    position: relative;
    width: 66%;
    height: 78%;
    margin: 7% auto 0 18%;
  }

  .book-left {
    width: 48%;
    padding: 8px;
  }

  .book-item-video {
    border: 1px solid #5D4037;
    overflow: hidden;
    padding: 8px;
    margin-bottom: 16px;
    cursor: pointer;
  }

  .video-thumbnail {
    float: left;
    width: 42%;
    margin-right: 8px;
  }

  .video-title {
    padding-top: 4px;
    font-weight: bold;
  }

  .video-description {
    padding-top: 4px;
  }

  .back-button-south {
    position: absolute;
    bottom: 0;
  }

  .youtube-embed {
    width: 560px;
    height: 315px;
  }

  @media screen and (max-width: 600px) {

    .book-left {
      padding: 2px;
    }

    .book-item-video {
      padding: 2px;
      margin-bottom: 2px;
    }

    .video-thumbnail {
      width: 100%;
    }

    .video-title,
    .video-description {
      display: none;
    }

    .youtube-embed {
      width: 263px;
      height: 148px;
    }

  }

</style>